window.Vue = require('vue');
window.vueEventHub = new Vue();

import Vue from 'vue';


window.Vue.component('bold-words',require('../../../../app/Shared/Resources/Assets/js/components/BoldWords.vue'))
if(document.querySelector('.carousel-3d-film-roll--contents') !== null){
	window.Vue.component(
		'carousel_3d',
		require('../components/front/carousel/carousel_3d.vue'));
}
window.Vue.component(
	'performance-test',
	require('../components/layouts/PerformanceTest.vue')
	);

if(document.querySelector('.vue2-event_module') !== null){
	window.Vue.component(
		'event_module',
		require('../components/front/modules/eventModule.vue'));
}
window.Vue.component(
	'cookie-consent',
	require('../components/cookies/CookieConsent'));
window.Vue.component(
	'cookiespage',
	require('../components/cookies/CookiesPage'));

window.Vue.component(
	'BaseButton',
	require('../../../../app/Shared/Resources/Assets/js/components/base/buttons/BaseButton'));

window.Vue.component(
	'BaseButtonRound',
	require('../../../../app/Shared/Resources/Assets/js/components/base/buttons/BaseButtonRound'));

window.Vue.component(
	'InfoButton',
	require('../../../../app/Shared/Resources/Assets/js/components/buttons/InfoButton'));

window.Vue.component(
	'BaseIcon',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseIcon'));
window.Vue.component(
	'event_module',
	require('../components/front/modules/eventModule.vue'));

window.Vue.component(
	'base-button',
	require('../../../../app/Shared/Resources/Assets/js/components/buttons/Buttons'));


window.Vue.component(
	'date-block',
	require('../components/dates/DateBlock'));

window.Vue.component(
	'upsell-card-row',
	require('../components/front/modules/upsellCardRow.vue'));
window.Vue.component(
	'event-tile-cards',
	require('../components/front/modules/eventTileCards'));

window.Vue.component(
	'simple_search',
	require('../components/front/search/simple-search.vue'));
window.Vue.component(
	'global_search',
	require('../components/front/search/global-search.vue'));
window.Vue.component(
	'modal_basket',
	require('../components/modals/Basket.vue'));

window.Vue.component(
	'event-quick-buy',
	require('../components/layouts/EventQuickBuy.vue')
);
window.Vue.component(
	'BundleSeasonTickets',
	require('../components/layouts/BundleSeasonTickets.vue')
);
//BundleSeasonTickets
window.Vue.component('checkout-form',require('../components/checkout/CheckoutForm'));
// window.Vue.component('checkout-items',require('../components/checkout/CheckoutItems'));
// car parks will display the ticket list and map

window.Vue.component(
	'main-navigation',
	require('../components/nav/MainNavigation.vue'));
window.Vue.component(
	'main-navigation-side-nav',
	require('../components/nav/MainNavigationSideNav.vue'));
window.Vue.component(
	'calendar-list',
	require('../components/lists/CalendarList.vue'));

// account stuff
window.Vue.component(
	'account-side-bar',
	require('../components/pages/account/AccountSideBar.vue'));
window.Vue.component(
	'account-tickets',
	require('../components/pages/account/AccountTickets.vue'));
window.Vue.component(
	'account-vip-tickets',
	require('../components/pages/account/AccountVIPTickets.vue'));
window.Vue.component(
	'account-event',
	require('../components/pages/account/AccountEvent.vue'));
window.Vue.component(
	'account-subscriber',
	require('../components/pages/account/AccountSubscriber'));

window.Vue.component(
	'event-list',
	require('../components/lists/EventList.vue'));
window.Vue.component(
	'tile-list-item',
	require('../components/tiles/TileListItem.vue'));

window.Vue.component(
	'season-ticket-list-item',
	require('../components/tickets/SeasonTicketListItem'));



window.Vue.component(
	'list-provided-search',
	require('../components/front/search/list-provided-search'));
window.Vue.component(
	'team-vs-team',
	require('../components/teams/TeamVsTeam'));
/*
window.Vue.component(
	'film-roll-item',
	require('../components/film-roll/FilmRollItem.vue'));
*/

window.Vue.component('telephone-format',
	require('../../../../app/Shared/Resources/Assets/js/components/TelephoneFormat.vue'));

window.Vue.component('BaseLoadingAnimation',
	require('../../../../app/Shared/Resources/Assets/js/components/base/BaseLoadingAnimation'));

window.Vue.component('team-list-item',
	require('../components/teams/teamListItem.vue'));

if(document.querySelector('.vue2-google-maps-init') !== null){
	window.Vue.component(
		'event-tickets',
		require('../components/pages/events/EventTickets.vue'));
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/vueComponents.js